type Colors = {
  primary: string;
  light: string;
  medium: string;
  dark: string;
  background: string;
  black: string;
  white: string;
  success: string;
  lightRed: string;
  delay: string;
  discount: string;
  gradientBeginner: string;
  gradientIntermediate: string;
  gradientAdvanced: string;
  radialGradient: string;
  mediumRGB: string;
  /** Text on primary-tinted surfaces (Figma info card, ERS-61) — darker than `primary` for contrast. */
  primaryDarkText: string;
  /** Error text on white — `lightRed` is below the WCAG AA 4.5:1 contrast for small text. */
  errorText: string;
};

export const colors: Colors = {
  primary: "#00b8e1",
  light: "#eff1f1",
  medium: "#607F90",
  dark: "#1e3542",
  success: "#3CBB00",
  discount: "#16C08A",
  background: "#FCFDFD",
  white: "#FFFFFF",
  black: "#000000",
  lightRed: "#D65A56",
  delay: "#FFAE00",
  mediumRGB: "96, 127, 144",
  primaryDarkText: "#0092B3",
  errorText: "#B3403C",
  gradientBeginner: "linear-gradient(45deg, #00a4c9, #00d1ff)",
  gradientIntermediate: "linear-gradient(45deg, #0D6997, #009FEF)",
  gradientAdvanced: "linear-gradient(45deg, #2F5574, #165C95)",
  radialGradient: "radial-gradient(circle at bottom, #38dbff, #00b8e1);",
};

export const getMediumRGBA = (opacity: number) =>
  `rgba(${colors.mediumRGB}, ${opacity})`;
